import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useOccurenceLocationChartsDataContext } from './hooks/useOccurenceLocationChartsDataContext';

export const OcurrenceLocation = () => {
    const { chartData } = useOccurenceLocationChartsDataContext();

    return (
        <Donut
            title={'Local de ocorrência'}
            subtitles={chartData?.ocurrenceLocation?.map((item) => item.description)}
            chartData={chartData?.ocurrenceLocation || []}
            colors={defaultColors.slice(0, chartData?.ocurrenceLocation?.length) || []}
            height={400}
            className='aligned-container'
        />
    );
};
